import {USER_INITIALS_COLOR_CODES} from 'Theme/capTokens';

/**
 * @summary Deterministic avatar background color per agent name.
 * Same name always hashes to the same color (from the design system's
 * dedicated avatar palette in Theme/capTokens.ts), so a given agent's avatar
 * looks the same everywhere/every session without needing to persist a
 * per-user color assignment anywhere.
 */
const getAvatarColor = (name?: string): string => {
  if (!name) return USER_INITIALS_COLOR_CODES[0];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash |= 0; // keep as a 32-bit int
  }
  const index = Math.abs(hash) % USER_INITIALS_COLOR_CODES.length;
  return USER_INITIALS_COLOR_CODES[index];
};

export default getAvatarColor;
